module.exports = __webpack_public_path__ + "img/04.94447f15.png";